import { useMemo } from 'react';

import { useContractSignedRecentlyQuery } from 'core/graphql';

import {
  contractAmountRows,
  toContractsSignedRecentVariables,
} from './contractsBoardModel';
import { IContractDocumentsFilters } from './useContractDocuments';
import { useEsignPermissions } from './useEsignPermissions';

/**
 * ТЗ 0106 — плитки «Подписано за 30 дней» и «Сумма подписанных за 30 дней»:
 * подписанные (`completed`) с `signedFrom` = сегодня по Варшаве минус 30 дней
 * под прочими фильтрами списка. `ready=false` — ответа ещё нет.
 */
export const useContractSignedRecently = (
  filters: IContractDocumentsFilters,
  enabled = true,
) => {
  const { canOpenPage } = useEsignPermissions();
  const { data, previousData } = useContractSignedRecentlyQuery({
    variables: toContractsSignedRecentVariables(filters),
    skip: !enabled || !canOpenPage,
    fetchPolicy: 'cache-and-network',
  });
  const shown = data ?? previousData;
  const amounts = shown?.contractDocumentAmounts;
  const rows = useMemo(() => contractAmountRows(amounts ?? []), [amounts]);
  return {
    ready: Boolean(shown),
    count: shown?.contractDocumentsTotal ?? 0,
    amounts: rows,
  };
};
